'use strict';

function LocationDetailsElm() {}

angular.module('pmtPlacesApp.controllers').component('pmtLocationDetailsElm', {
	controller: LocationDetailsElm,
	templateUrl: 'components/location/pmtLocationDetailsElm.html'
});
